import React, {useState} from "react";
import NiceModal from "@ebay/nice-modal-react";
import {CustomDialog} from "@bounce/shared/ui";
import {TextField} from "../../ui/components";

type Props = {
  currentName: string;
  onConfirm: (name: string) => void;
};

const RenameAssetDialog = NiceModal.create(({currentName, onConfirm}: Props) => {
  const [name, setName] = useState(currentName);
  const trimmed = name.trim();

  return (
    <CustomDialog
      title="Rename asset"
      forceTitle
      buttonText="Rename"
      width="420px"
      disabled={!trimmed || trimmed === currentName}
      onClick={() => onConfirm(trimmed)}
    >
      <TextField
        fullWidth
        autoFocus
        size="small"
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
    </CustomDialog>
  );
});

export default RenameAssetDialog;
